<template>
    <div class="izjava-privatnosti">
        <h2>IZJAVA O PRIVATNOSTI</h2>
        <p>
            SPIKA - Škola stranih jezika vodi računa o privatnosti i zaštiti podataka svojih klijenata i posjetitelja web stranice.

            Pažljivo pročitajte sljedeću izjavu kako biste saznali koje informacije možemo prikupiti od Vas, kako ih možemo upotrijebiti i koja su Vaša prava u vezi s našom upotrebom podataka.

            Prilikom obrade podataka vodit ćemo se sljedećim načelima:

            Prikupljat ćemo podatke samo za određene i navedene svrhe.
            Nećemo koristiti podatke u druge svrhe, osim uz prethodnu suglasnost.
            Nećemo prenositi podatke trećim stranama.
            Podatke ćemo ažurirati nakon što primimo zahtjev za njihovom izmjenom.
            Primijenit ćemo visoke tehničke standarde pri čuvanju sigurnosti Vaših podataka.
            Vaše podatke obrađivat ćemo i pohranjivati  samo onoliko dugo koliko to zahtijeva ugovor ili zakon.

            Podatke koje skupljamo koristimo u sljedeće svrhe:

            kako bismo komunicirali s Vama
            kako biste mogli koristiti naše usluge (online test procjene znanja i dr.)
            kako bismo mogli udovoljiti Vašim zahtjevima i pružiti Vam traženu uslugu
            kako bismo Vam mogli slati obavijesti ili promotivne materijale
            kako bismo unaprijedili naše poslovanje
            u ostale svrhe uz Vaš pristanak
            IP adrese i kolačići

            Pregledavanje naše web stranice je anonimno i tom se prilikom ne prikupljaju Vaši osobni podaci kao što su osobno ime ili kontakt podaci.

            Pri posjeti našoj web stranici, alat Google Analytics može prikupiti informacije o vašem računalu kao što je vaša IP adresa, operativni sustav i vrsta preglednika za korisničku analizu. Možemo dobiti informacije o vašoj općoj internetskoj upotrebi pomoću kolačića, koji  pomažu poboljšati našu web stranicu i pružiti bolju i personaliziranu uslugu. Postavke kolačića možete mijenjati u internetskom pregledniku koji koristite. Ako ih onemogućite, još uvijek možete posjetiti našu web stranicu, no ne možemo Vam jamčiti optimalno iskustvo bez kolačića.

            U svakom trenutku imate pravo na uvid u podatke koji su o Vama pohranjeni i na koji način, pravo na ažuriranje tih podataka, kao i pravo na prigovor ili povlačenje privole. Sve informacije o tome možete dobiti pismenim putem na hello@spika.hr  ili na broj telefona 098 187 9400.
        </p>
    </div>
</template>

<script>
export default {
  name: "Privatnost",
};
</script>